import { breakpoints } from '@styles/breakpoints';
import { style, styleVariants } from '@vanilla-extract/css';

const tablet = `screen and (min-width: ${breakpoints.tablet})`;

export const layout = styleVariants({
  column: { flexDirection: 'column' },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    justifyContent: 'center',
    gap: '0.75rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(12.5rem, 1fr))', // 200px
    gridAutoRows: '1fr',
    gap: '1rem',
    '@media': {
      [tablet]: { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' },
    },
  },
  gridPairs: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridAutoRows: '1fr',
    gap: '1rem',
    '@media': {
      [tablet]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      },
    },
  },
});

export const rowCell = style({ flex: 1 });

export const fullRow = style({ gridColumn: '1 / -1' });
